import { useEffect, useState } from "react";
import { ReportsService } from "../../services/ReportsService";
import { ReportViewer } from "./Report";

export function ReportGlobalPage() {
  const [config, setConfig] = useState();
  useEffect(() => {
    ReportsService.getAll().then((data) => setConfig(data));
  }, []);

  return config ? <ReportViewer config={config} /> : null;
}
